/**
 * Return yyyy-mm-dd form of javascript Date object
 **/
export function getDateJson(date: Date) {
	const year = date.getFullYear()
	let month = '' + (date.getMonth() + 1)
	let day = '' + date.getDate()
	if (month.length < 2) {
		month = '0' + month
	}
	if (day.length < 2) {
		day = '0' + day
	}
	return [year, month, day].join('-')
}

export function validDate(value: string) {
	if (typeof value !== 'string') {
		console.error('type is', typeof value)
		return false
	}
	if (value.length !== '2006-01-02'.length) {
		console.error('length is', value.length)
		return false
	}
	const year = parseInt(value.substr(0, 4))
	if (year < 0 || year > 9999) {
		console.error('year is', year)
		return false
	}
	const month = parseInt(value.substr(5, 2))
	if (month < 1 || month > 12) {
		console.error('month is', month)
		return false
	}
	const day = parseInt(value.substr(8, 2))
	if (day < 1 || day > 31) {
		console.error('day is', day)
		return false
	}
	return true
}

/**
 * Get current day as string on user's system
 **/
export function getCurrentDay() {
	return getDateJson(new Date())
}

export function parseDate(date: string) {
	const [year, month, day] = date.split('-')
	return new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
}

export type GoDate = {
	Day:   number
	Month: number
	Year:  number
}
export function parseGoDate(date: GoDate) {
	return new Date(date.Year, date.Month-1, date.Day)
}
/**
 * Given string yyyy-mm-dd, return yyyy-mm-dd days after
 */
export function getDateAfterDays(current: string, days: number) {
	const date = parseDate(current)
	date.setDate(date.getDate() + days)
	return getDateJson(date)
}

/*
  const MONTH_LOOKUP = {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December",
  };
  */

/**
 * Jan 7, 2021 format
 */
type FormatDateJames = 'short' | 'numeric' | '2-digit' | 'long' | 'narrow' | undefined

export function jamesFormat(date: string, format?: FormatDateJames) {
	format = format || 'short'

	return jFormat(parseDate(date), format)
	// return parseDate(date).toLocaleDateString('en-us', {
	// 	year: 'numeric',
	// 	day: 'numeric',
	// 	month: format
	// })
}

export function jFormat(date: Date, format?: FormatDateJames) {
	format = format || 'short'
	return date.toLocaleDateString('en-us', {
		year: 'numeric',
		day: 'numeric',
		month: format
	})
}

export function dateStringClearTime(dateString: string): string {
	// Parse the input date string
	const date = new Date(dateString)
	return dateClearTime(date)
}

export function dateClearTime(date: Date): string {
	// Format the date to YYYY-MM-DD
	date = new Date(date)
	const year = date.getUTCFullYear()
	const month = String(date.getUTCMonth() + 1).padStart(2, '0')
	const day = String(date.getUTCDate()).padStart(2, '0')
  
	const result = `${year}-${month}-${day}`
	return result
}

export function humanizeSince(timestamp: number) {
	const then = new Date(timestamp)
	const now = new Date()
	const seconds = (now.getTime() - then.getTime()) / 1000

	if (seconds < 60) {
		return 'seconds ago'
	}
	const minutes = Math.round(seconds / 60)
	if (minutes <= 1) {
		return '1 minute ago'
	}
	if (minutes < 60) {
		return `${minutes} minutes ago`
	}
	const hours = Math.round(minutes / 60)
	if (hours <= 1) {
		return '1 hour ago'
	}
	if (hours < 24) {
		return `${hours} hours ago`
	}
	//	const days = Math.round(hours / 60);
	const days = Math.round(hours / 24)
	if (days <= 1) {
		return 'yesterday'
	}
	if (days < 7) {
		return `${days} days ago`
	}
	const weeks = Math.round(days / 7)
	if (weeks <= 1) {
		return '1 week ago'
	}
	if (weeks <= 4) {
		return `${weeks} weeks ago`
	}
	//	const months = Math.round((weeks / 52) * 12);
	const months = Math.round(days / 30)
	if (months <= 1) {
		return '1 month ago'
	}
	if (months <= 12) {
		return `${months} months ago`
	}
	//	const years = Math.round(months / 12);
	const years = Math.round(days / 365)
	if (years <= 1) {
		return '1 year ago'
	}

	return `${years} years ago`
}

// export const timestampToDate = (timestamp: string): Date | undefined => {
// 	const number = parseInt(timestamp) * 1000
// 	try {
// 		return new Date(number)
// 	} catch (err) {
// 		return undefined
// 	}
// }

export const timestampToDateString = (timestamp: string): string => {
	const number = parseInt(timestamp) * 1000
	try {
		return new Date(number).toISOString()
	} catch (err) {
		return ''
	}
}

export const humanizeDateTime = (date: string): string => {
	return humanizeSince(Date.parse(date))
}

export const getDateTimeShortFormat = (date: string): string => {
	//let d = parseDate(date)
	const d = new Date(Date.parse(date))
	const options: Intl.DateTimeFormatOptions = {
		month: 'short',
		day: 'numeric',
		hour: 'numeric',
		minute: 'numeric'
	}
	//options.timeZone = 'UTC';

	//return d.toLocaleDateString('en-US', options)
	return d.toLocaleDateString(undefined, options)
}

export const getDateTimeLongFormat = (date: string): string => {
	//let d = parseDate(date)
	const d = new Date(Date.parse(date))
	const options: Intl.DateTimeFormatOptions = {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
		hour: 'numeric',
		minute: 'numeric'
	}
	//options.timeZone = 'UTC';

	//return d.toLocaleDateString('en-US', options)
	return d.toLocaleDateString(undefined, options)
}
